import {
  toWorkspaceAgentPillClipsById,
  type WorkspaceAgentPillClip,
  type WorkspaceAgentPillClipSource,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/toWorkspaceAgentPillClipsById';

export type WorkspaceAgentPillCoverSource = WorkspaceAgentPillClipSource & {
  assetId: string;
};

export type WorkspaceAgentPillCover = {
  clip: WorkspaceAgentPillClip;
  /** Cover version id, which is the clip id the asset modal and card details read. */
  clipId: string;
};

/** Keyed by asset id. `Assets.listCoverVersionsByAssetIds` returns one cover clip per asset. */
export const toWorkspaceAgentPillCoversByAssetId = (
  clips: readonly WorkspaceAgentPillCoverSource[],
): Map<string, WorkspaceAgentPillCover> => {
  const clipsById = toWorkspaceAgentPillClipsById([...clips]);

  return new Map(
    clips.flatMap((source) => {
      const clip = clipsById.get(source.id);

      if (!clip) {
        return [];
      }

      const entry: [string, WorkspaceAgentPillCover] = [source.assetId, { clip, clipId: source.id }];

      return [entry];
    }),
  );
};
